// pages/Home.js
import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import MyNavbar from '../components/MyNavbar';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import './Home.css';
import KBCommonsLogo from '../assets/images/kbcommons-logo.png';
import SoyKBLogo from '../assets/images/soykb-logo.png';
import CrossMPLogo from '../assets/images/crossmp-logo.png';
import G2PDeepLogo from '../assets/images/G2PDeep-logo.png';
import OmicsverseLogo from '../assets/images/omicsverse-logo.png';
import ScPlantAnnotateLogo from '../assets/images/ScPlantAnnotate-logo1.png';
import SarsCov2Logo from '../assets/images/sars-cov-2-portal-logo1.png';
import IRNETLogo from '../assets/images/Irnet-logo.png';
const Home = () => {
    return (
        <div className="home-page">
            <MyNavbar />
            <HeroSection />

            <section id="highlights" className="py-5" style={{ backgroundColor: '#FAFAFA' }}>
                <Container>
                    <Row className="text-center mb-5">
                        <Col>
                            <h2 className="display-5 fw-bold mb-3" style={{ color: '#0A4B5D' }}>
                                Translational Bioinformatics Research
                            </h2>
                            <p className="lead" style={{ color: '#212529' }}>
                                Bridging computational innovation with clinical applications
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={3} md={6} className="mb-4">
                            <Card className="h-100 shadow-sm border-0 highlight-card">
                                <Card.Body className="p-4">
                                    <div className="icon-wrapper mb-3">
                                        <i className="fas fa-dna fa-2x" style={{ color: '#007BFF' }}></i>
                                    </div>
                                    <Card.Title style={{ color: '#0A4B5D' }}>Next Generation Sequencing</Card.Title>
                                    <Card.Text>
                                        Comprehensive NGS analyses including SNP/GWAS studies, RNA-Seq transcriptomics,
                                        microRNA studies, Chip-Seq/DAP-Seq, and Bisulphite sequencing for biomarker
                                        discovery and pharmacogenomics.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={3} md={6} className="mb-4">
                            <Card className="h-100 shadow-sm border-0 highlight-card">
                                <Card.Body className="p-4">
                                    <div className="icon-wrapper mb-3">
                                        <i className="fas fa-database fa-2x" style={{ color: '#00A86B' }}></i>
                                    </div>
                                    <Card.Title style={{ color: '#0A4B5D' }}>Precision Medicine & Knowledge Bases</Card.Title>
                                    <Card.Text>
                                        Developing comprehensive knowledge bases (SoyKB, CancerKB, MouseKB) through
                                        KBCommons framework for multi-omics data integration and personalized medicine.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={3} md={6} className="mb-4">
                            <Card className="h-100 shadow-sm border-0 highlight-card">
                                <Card.Body className="p-4">
                                    <div className="icon-wrapper mb-3">
                                        <i className="fas fa-project-diagram fa-2x" style={{ color: '#FF7B25' }}></i>
                                    </div>
                                    <Card.Title style={{ color: '#0A4B5D' }}>Systems Biology</Card.Title>
                                    <Card.Text>
                                        Computational modeling of complex biological systems using our IMPRes algorithm
                                        for pathway optimization and multi-omics data integration with dynamic programming.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={3} md={6} className="mb-4">
                            <Card className="h-100 shadow-sm border-0 highlight-card">
                                <Card.Body className="p-4">
                                    <div className="icon-wrapper mb-3">
                                        <i className="fas fa-virus fa-2x" style={{ color: '#8B5CF6' }}></i>
                                    </div>
                                    <Card.Title style={{ color: '#0A4B5D' }}>Genomic Epidemiology</Card.Title>
                                    <Card.Text>
                                        Tracking and analyzing pathogen evolution and transmission patterns using genomic data.
                                        Includes viral phylogenetics, antimicrobial resistance monitoring, outbreak investigation,
                                        and public health surveillance through whole genome sequencing and computational modeling.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section id="featured-tools" className="py-5" style={{ backgroundColor: '#FFFFFF' }}>
                <Container>
                    <Row className="text-center mb-5">
                        <Col>
                            <h2 className="display-5 fw-bold mb-3" style={{ color: '#0A4B5D' }}>
                                Bioinformatics Tools & Platforms
                            </h2>
                        </Col>
                    </Row>
                    <Row>
                        {/* KBCommons */}
                        <Col lg={4} md={6} className="mb-4">
                            <Card className="h-100 shadow border-0">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <img
                                            src={KBCommonsLogo}
                                            alt="KBCommons"
                                            style={{
                                                height: '40px',
                                                width: 'auto',
                                                marginRight: '12px'
                                            }}
                                        />
                                        <Card.Title className="mb-0" style={{ color: '#0A4B5D' }}>KBCommons</Card.Title>
                                    </div>
                                    <Card.Text>
                                        A framework that automates database establishment and provides informatics tools
                                        and visualization capabilities for multiple organisms. Incorporates transcriptomics,
                                        proteomics, metabolomics, epigenomics, and molecular breeding data.
                                    </Card.Text>
                                    <Button
                                        variant="outline-primary"
                                        href="http://kbcommons.org"
                                        target="_blank"
                                        className="mt-2"
                                    >
                                        Visit Platform
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* SoyKB */}
                        <Col lg={4} md={6} className="mb-4">
                            <Card className="h-100 shadow border-0">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <img
                                            src={SoyKBLogo}
                                            alt="SoyKB"
                                            style={{
                                                height: '40px',
                                                width: 'auto',
                                                marginRight: '12px'
                                            }}
                                        />
                                    </div>
                                    <Card.Text>
                                        A comprehensive knowledge base for soybean research, providing integrated genomics,
                                        transcriptomics, proteomics, and metabolomics data for soybean and related species.
                                    </Card.Text>
                                    <Button
                                        variant="outline-primary"
                                        href="https://soykb.org/"
                                        target="_blank"
                                        className="mt-2"
                                    >
                                        Access SoyKB
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* CrossMP */}
                        <Col lg={4} md={6} className="mb-4">
                            <Card className="h-100 shadow border-0">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <img
                                            src={CrossMPLogo}
                                            alt="CrossMP"
                                            style={{
                                                height: '40px',
                                                width: 'auto',
                                                marginRight: '12px'
                                            }}
                                        />
                                    </div>
                                    <Card.Text>
                                        A web-based portal for cross-modality translation between single-cell RNA-seq and single-cell ATAC-seq data.
                                        It lets researchers upload one modality and predict the other using deep neural network modeling.
                                    </Card.Text>
                                    <Button
                                        variant="outline-primary"
                                        href="https://crossmp.missouri.edu/"
                                        target="_blank"
                                        className="mt-2"
                                    >
                                        Access CrossMP
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* IRNET */}
                        <Col lg={4} md={6} className="mb-4">
                            <Card className="h-100 shadow border-0">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <img
                                            src={IRNETLogo}
                                            alt="IRNET"
                                            style={{
                                                height: '40px',
                                                width: 'auto',
                                                marginRight: '12px'
                                            }}
                                        />
                                    </div>
                                    <Card.Text>
                                        A comprehensive platform for integrative regulatory network analysis, providing
                                        tools for reconstructing and analyzing gene regulatory networks from multi-omics
                                        data to uncover key regulatory mechanisms in biological systems.
                                    </Card.Text>
                                    <Button
                                        variant="outline-primary"
                                        href="https://irnet.missouri.edu/"
                                        target="_blank"
                                        className="mt-2"
                                    >
                                        Access IRNET
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* G2Deep */}
                        <Col lg={4} md={6} className="mb-4">
                            <Card className="h-100 shadow border-0">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <img
                                            src={G2PDeepLogo}
                                            alt="G2Deep"
                                            style={{
                                                height: '40px',
                                                width: 'auto',
                                                marginRight: '12px'
                                            }}
                                        />
                                    </div>
                                    <Card.Text>
                                        Genotype-to-Phenotype Deep Learning platform for predicting complex traits from
                                        genomic data. Uses advanced deep learning models to bridge the gap between genetic
                                        variations and phenotypic outcomes in various organisms.
                                    </Card.Text>
                                    <Button
                                        variant="outline-primary"
                                        href="https://g2pdeep.org/"
                                        target="_blank"
                                        className="mt-2"
                                    >
                                        Use G2Deep
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* IMPRes */}
                        <Col lg={4} md={6} className="mb-4">
                            <Card className="h-100 shadow border-0">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <Card.Title className="mb-0 p-2 rounded" style={{
                                            color: 'white',
                                            backgroundColor: '#0A4B5D',
                                            padding: '8px 16px'
                                        }}>
                                            IMPRes
                                        </Card.Title>
                                    </div>
                                    <Card.Text>
                                        Step-wise active pathway optimization and detection method using dynamic programming
                                        and multi-omics data as evidence. Incorporates KEGG pathways, transcriptomics and
                                        protein-protein interactions as background networks.
                                    </Card.Text>
                                    <Button
                                        variant="outline-primary"
                                        href="https://impres.missouri.edu/impres"
                                        target="_blank"
                                        className="mt-2"
                                    >
                                        Access IMPRes
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Omicsverse */}
                        <Col lg={4} md={6} className="mb-4">
                            <Card className="h-100 shadow border-0">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <img
                                            src={OmicsverseLogo}
                                            alt="Omicsverse"
                                            style={{
                                                height: '40px',
                                                width: 'auto',
                                                marginRight: '12px',
                                                backgroundColor: 'black'
                                            }}
                                        />
                                        <Card.Title className="mb-0" style={{ color: '#0A4B5D' }}>Omicsverse</Card.Title>
                                    </div>
                                    <Card.Text>
                                        A comprehensive multi-omics data integration and analysis platform that enables
                                        researchers to explore, visualize, and interpret complex biological datasets
                                        across different omics layers in a unified environment.
                                    </Card.Text>
                                    <Button
                                        variant="outline-primary"
                                        href="https://omicsverse.missouri.edu/"
                                        target="_blank"
                                        className="mt-2"
                                    >
                                        Explore Omicsverse
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* scPlantAnnotate */}
                        <Col lg={4} md={6} className="mb-4">
                            <Card className="h-100 shadow border-0">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <img
                                            src={ScPlantAnnotateLogo}
                                            alt="scPlantAnnotate"
                                            style={{
                                                height: '40px',
                                                width: 'auto',
                                                marginRight: '12px'
                                            }}
                                        />
                                        <Card.Title className="mb-0" style={{ color: '#0A4B5D' }}>scPlantAnnotate</Card.Title>
                                    </div>
                                    <Card.Text>
                                        A web-based deep learning tool for automated cell-type annotation in plant single-cell
                                        RNA sequencing (scRNA-seq) data. It uses transformer-based models optimized for plants
                                        to provide accurate and efficient identification of plant cell types across multiple species.
                                    </Card.Text>
                                    <Button
                                        variant="outline-primary"
                                        href="https://scplantannotate.missouri.edu/"
                                        target="_blank"
                                        className="mt-2"
                                    >
                                        Access scPlantAnnotate
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* SARS-CoV2 */}
                        <Col lg={4} md={6} className="mb-4">
                            <Card className="h-100 shadow border-0">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <img
                                            src={SarsCov2Logo}
                                            alt="SARS-CoV2"
                                            style={{
                                                height: '40px',
                                                width: 'auto',
                                                marginRight: '12px'
                                            }}
                                        />
                                        <Card.Title className="mb-0" style={{ color: '#0A4B5D' }}>SARS-CoV2 Genomics</Card.Title>
                                    </div>
                                    <Card.Text>
                                        The Covid-19 Genomics Surveillance Portal provides the trends in the identified variants of concern (VOC) and the regional map showing counties with total number of sequenced samples.
                                    </Card.Text>
                                    <Button
                                        variant="outline-primary"
                                        href="https://dataportals.missouri.edu/SARSCoV2"
                                        target="_blank"
                                        className="mt-2"
                                    >
                                        Use SARS-CoV2 Portal
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section id="affiliations" className="py-5" style={{ backgroundColor: '#F8F9FA' }}>
                <Container>
                    <Row className="text-center mb-5">
                        <Col>
                            <h2 className="display-5 fw-bold mb-3" style={{ color: '#0A4B5D' }}>
                                Funding Sources & Affiliations
                            </h2>
                        </Col>
                    </Row>

                    {/* Horizontal Scrollable Row */}
                    <Row className="flex-nowrap overflow-auto pb-3" style={{ scrollbarWidth: 'thin' }}>
                        {/* Marshall University Logo */}
                        <Col className="flex-shrink-0" style={{ width: '220px' }}>
                            <a href="https://www.marshall.edu/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                <Card className="h-100 shadow-sm border-0 funding-card">
                                    <Card.Body className="text-center p-3 d-flex flex-column">
                                        <div className="funding-logo mb-2">
                                            <img
                                                src="/images/marshall-university-logo.png"
                                                alt="Marshall University"
                                                className="img-fluid"
                                                style={{ maxHeight: '60px', objectFit: 'contain' }}
                                            />
                                        </div>
                                        <Card.Text className="mt-auto fw-semibold small" style={{ color: '#0A4B5D' }}>
                                            Marshall University
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </a>
                        </Col>

                        {/* NSF */}
                        <Col className="flex-shrink-0" style={{ width: '220px' }}>
                            <a href="https://www.nsf.gov/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                <Card className="h-100 shadow-sm border-0 funding-card">
                                    <Card.Body className="text-center p-3 d-flex flex-column">
                                        <div className="funding-logo mb-2">
                                            <img
                                                src="/images/nsfgood.jpg"
                                                alt="National Science Foundation"
                                                className="img-fluid"
                                                style={{ maxHeight: '60px', objectFit: 'contain' }}
                                            />
                                        </div>
                                        <Card.Text className="mt-auto fw-semibold small" style={{ color: '#0A4B5D' }}>
                                            U.S. National Science Foundation
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </a>
                        </Col>

                        {/* Department of Energy */}
                        <Col className="flex-shrink-0" style={{ width: '220px' }}>
                            <a href="https://www.energy.gov/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                <Card className="h-100 shadow-sm border-0 funding-card">
                                    <Card.Body className="text-center p-3 d-flex flex-column">
                                        <div className="funding-logo mb-2">
                                            <img
                                                src="/images/DoeSeal.png"
                                                alt="Department of Energy"
                                                className="img-fluid"
                                                style={{ maxHeight: '60px', objectFit: 'contain' }}
                                            />
                                        </div>
                                        <Card.Text className="mt-auto fw-semibold small" style={{ color: '#0A4B5D' }}>
                                            Department of Energy
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </a>
                        </Col>

                        {/* Missouri Department of Health */}
                        <Col className="flex-shrink-0" style={{ width: '220px' }}>
                            <a href="https://health.mo.gov/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                <Card className="h-100 shadow-sm border-0 funding-card">
                                    <Card.Body className="text-center p-3 d-flex flex-column">
                                        <div className="funding-logo mb-2">
                                            <img
                                                src="/images/HSSI.png"
                                                alt="Missouri Department of Health and Senior Services"
                                                className="img-fluid"
                                                style={{ maxHeight: '60px', objectFit: 'contain' }}
                                            />
                                        </div>
                                        <Card.Text className="mt-auto fw-semibold small" style={{ color: '#0A4B5D' }}>
                                            Missouri Department of Health
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </a>
                        </Col>

                        {/* United Soybean Board */}
                        <Col className="flex-shrink-0" style={{ width: '220px' }}>
                            <a href="https://www.unitedsoybean.org/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                <Card className="h-100 shadow-sm border-0 funding-card">
                                    <Card.Body className="text-center p-3 d-flex flex-column">
                                        <div className="funding-logo mb-2">
                                            <img
                                                src="/images/soy.jpg"
                                                alt="United Soybean Board"
                                                className="img-fluid"
                                                style={{ maxHeight: '60px', objectFit: 'contain' }}
                                            />
                                        </div>
                                        <Card.Text className="mt-auto fw-semibold small" style={{ color: '#0A4B5D' }}>
                                            United Soybean Board
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </a>
                        </Col>

                        {/* NIH */}
                        <Col className="flex-shrink-0" style={{ width: '220px' }}>
                            <a href="https://www.nih.gov/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                <Card className="h-100 shadow-sm border-0 funding-card">
                                    <Card.Body className="text-center p-3 d-flex flex-column">
                                        <div className="funding-logo mb-2">
                                            <img
                                                src="/images/NIHlogo.png"
                                                alt="National Institutes of Health"
                                                className="img-fluid"
                                                style={{ maxHeight: '60px', objectFit: 'contain' }}
                                            />
                                        </div>
                                        <Card.Text className="mt-auto fw-semibold small" style={{ color: '#0A4B5D' }}>
                                            National Institutes of Health
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </a>
                        </Col>

                        {/* University of Missouri */}
                        <Col className="flex-shrink-0" style={{ width: '220px' }}>
                            <a href="https://missouri.edu/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                <Card className="h-100 shadow-sm border-0 funding-card">
                                    <Card.Body className="text-center p-3 d-flex flex-column">
                                        <div className="funding-logo mb-2">
                                            <img
                                                src="/images/Mizzou.png"
                                                alt="University of Missouri"
                                                className="img-fluid"
                                                style={{ maxHeight: '60px', objectFit: 'contain' }}
                                            />
                                        </div>
                                        <Card.Text className="mt-auto fw-semibold small" style={{ color: '#0A4B5D' }}>
                                            University of Missouri
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </a>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* CTA Section */}
            <section className="py-5" style={{ backgroundColor: '#0A4B5D', color: 'white' }}>
                <Container>
                    <Row className="text-center">
                        <Col lg={8} className="mx-auto">
                            <h3 className="fw-bold mb-4">Join Our Research Team</h3>
                            <p className="lead mb-4">
                                We're looking for passionate students and researchers interested in translational
                                bioinformatics, computational biology, and multi-omics data analysis.
                            </p>
                            <Button
                                variant="warning"
                                size="lg"
                                href="/contact"
                                className="fw-semibold me-3"
                            >
                                Contact Us
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Footer />
        </div>
    );
};

export default Home;